  <template>
  <div class="warranty">
    <div :class="['warranty__content', { 'with-error': warrantyError }]">
      <div class="top-content">
        <div class="text-wrap">
          <h2 class="title">Autoversicherung</h2>
        </div>
        <div class="shield">
          <div class="shield-content">
            <p>In Zusammenarbeit mit</p>
          </div>
        </div>
      </div>
      <form>
        <div
          :class="['radio-form-item', { active: warranty === true }]"
          @click="() => handleCheckboxChange(true)"
        >
          <input :checked="warranty === true" type="radio" />
          <div class="radio-form-item__top-content">
            <div class="price-wrap">
              <p style="padding-left: 30px">
                <b>Ja</b>, ich bin an einem <b>unverbindlichen Angebot</b> für
                eine Autoversicherung interessiert.
                <br />
                <b>FRIDAY Original</b>: Zum Preis-Leistungs-Sieger ab 7,49 Euro
                pro Monat
              </p>
            </div>
            <div class="list-wrap">
              <ul class="check-list">
                <li>Digital in 90 Sekunden abschließen</li>
                <li>Faire kilometergenaue Abrechnung</li>
                <!-- <li>Monatlich kündbar</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div
          :class="['radio-form-item', { active: warranty === false }]"
          @click="() => handleCheckboxChange(false)"
        >
          <input :checked="warranty === false" type="radio" />
          <div class="radio-form-item__top-content">
            <div class="price-wrap">
              <p style="padding-left: 30px">
                <b>Nein</b>, ich möchte kein Angebot zur Autoversicherung
                erhalten.
              </p>
            </div>
          </div>
        </div>

        <p v-if="warrantyError" class="error">Bitte Option wählen.</p>
      </form>
    </div>
    <div class="btns">
      <button class="btn" type="button" @click="updateOrderData">
        {{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}
      </button>
    </div>
  </div>
</template>

<script>
import WarrantyModal from "@/components/modals/WarrantyModal";

let isInitialValue = true;

export default {
  isInitialValue: true,
  components: {
    WarrantyModal,
  },
  props: ["order", "editMode"],
  data() {    
    return {
      warrantyError: false,
      warranty: isInitialValue ? null : this.order.friday_insurance,
    };
  },
  watch: {
    warranty(val) {
      if (this.warrantyError && !isInitialValue) {
        this.warrantyError = false;
      }
    },
  },
  methods: {
    mounted () {
      this.warranty = this.order?.friday_insurance || null
    },
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          friday_insurance: this.warranty,
        };
        this.$emit("updateOrderStep", this.order.token, params);
      }
    },
    validateForm() {
      let noError = true;
      if (this.warranty === null) {
        this.warrantyError = true;
        noError = false;
      } else {
        this.warrantyError = false;
      }
      if (noError) {
        this.warrantyError = false;
      }
      return noError;
    },
    handleCheckboxChange(value) {
      isInitialValue = false;

      this.warranty = value;
    },
  },
};
</script>

<style lang="scss">
.warranty {
  padding: 30px 0.625rem;
  &__content {
    .warranty-details {
      position: relative;
      padding: 20px;
      border: 1px solid #d6d6d6;
      line-height: 26px;
      margin-bottom: 20px;
      &.classic {
        .inactive:before {
          content: "\f00d";
          color: $red;
        }
      }
      &.premium {
        .inactive-premium:before {
          content: "\f00d";
          color: $red;
        }
      }
      &.basic {
        > p {
          margin-top: 20px;
        }
      }
      @include breakpoint(desktop) {
        padding: 25px 30px;
      }
      h4 {
        border-bottom: 1px solid #d8d8d8;
        padding-bottom: 15px;
      }
      h6 {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 700;
      }
      ul {
        li {
          margin-left: 0;
        }
      }
    }
    .options {
      .additional-plans {
        @include breakpoint(desktop) {
          display: flex;
          > div {
            width: 50%;
          }
          .warranty-details {
            margin-left: 15px;
          }
        }
      }
      .warranty-btn {
        width: 100%;
        border: 1px solid $red;
        border-radius: 25px;
        line-height: 50px;
        font-size: 14px;
        font-weight: 700;
        color: $red;
        &.desktop {
          display: none;
          @include breakpoint(desktop) {
            display: block;
          }
        }
        &.mobile {
          @include breakpoint(desktop) {
            display: none;
          }
        }
      }
      > h3 {
        margin-bottom: 20px;
      }
      .radio-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .top-item {
    margin-bottom: 45px;
    @include breakpoint(desktop) {
      .radio-form-item__top-content {
        display: flex;
        align-items: center;
        .list-wrap {
          margin: 0 0 0 40px;
        }
      }
      .radio-form-item input[type="radio"] {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .list-wrap {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      h3 {
        font-size: 16px;
      }
      .check-list {
        margin-top: 10px;
        li {
          margin-left: 0;
        }
      }
    }
  }
  .top-content {
    display: flex;
    flex-direction: column;
    @include breakpoint(desktop) {
      align-items: center;
      flex-direction: row;
    }
    .text-wrap {
      @include breakpoint(desktop) {
        flex: 3;
        margin-right: 30px;
        p {
          font-size: 18px;
        }
      }
      p {
        line-height: 30px;
      }
    }
  }
  .shield {
    position: relative;
    height: 60px;
    margin: 20px auto;
    font-size: 16px;
    text-align: center;
    @include breakpoint(desktop) {
      flex: 1;
    }
    &:after {
      content: "";
      position: absolute;
      top: 40px;
      left: 42px;
      width: 145px;
      height: 100%;
      background-color: $white;
      background: url("../assets/images/friday-logo.svg") no-repeat;
      background-size: contain;
    }
    &-content {
      position: relative;
      width: 230px;
      padding: 10px 0;
      margin-top: 0;
      padding-bottom: 5px;
      background-color: $white;
      z-index: 2;
    }
    &-title {
      font-size: 18px;
      font-weight: 700;
    }
  }
  .warranty__insuarance {
    margin-top: 20px;
    .radio-form-item__top-content {
      > p {
        margin-left: 10px;
        margin-top: 10px;
      }
      > div {
        flex-direction: column;
        @include breakpoint(desktop) {
          flex-direction: row;
          .radio-form-item__bell {
            width: 250px;
          }
        }
        h4 {
          font-weight: 400;
        }
        &.no-tires {
          flex-direction: column;
          &.with-error {
            .error {
              margin-left: 0;
              padding: 5px 0;
              font-size: 12px;
              line-height: 12px;
              color: $red;
            }
            input[type="checkbox"] + label:before {
              border-color: $red;
            }
          }
          .financed-plan-form__checkbox {
            margin: 30px 0;
            .custom-checkbox {
              input[type="checkbox"]:checked + label:after {
                top: 0;
              }
            }
            > div {
              display: flex;
              align-items: center;
              color: $red;
              > p {
                font-size: 14px;
                margin-left: 30px;
              }
            }
          }
        }
      }
    }
  }

  @include breakpoint(desktop) {
    padding: 0 0 30px;
  }

  .video {
    margin-top: 30px;
    max-width: 500px;
    h3 {
      margin-bottom: 20px;
      line-height: 30px;
    }
  }

  .warranty__note {
    padding: 10px;
    display: inline-block;
    margin-bottom: 20px;
  }

  .btns {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .btn-red {
      margin-right: 10px;
      font-weight: 400;
      border: 1px solid $red;
      background-color: transparent;
      color: $red;
    }
  }
  .radio-form-item {
    margin-bottom: 10px;
    &__main-content {
      margin: 20px 0 30px;
      button {
        color: $red;
      }
    }
    &__bell {
      margin: 10px 0 0 30px;
      font-size: 14px;
      font-weight: 700;
      color: $red;
      i {
        margin-right: 5px;
      }
    }
  }
  .check-list {
    margin-top: 20px;
  }
  .btn {
    margin-top: 10px;
  }
  .with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  .check-list button {
    padding: 0;
  }
  @include breakpoint(medium) {
    .btns {
      flex-direction: row;
    }
  }
  @include breakpoint(desktop) {
    .radio-form-item {
      &__main-content {
        display: flex;
        padding-left: 30px;
        > * {
          flex: 1;
        }
      }
    }
    &__note {
      padding-left: 30px;
    }
  }
}
</style>
